// Auth state: the current Firebase user, resolved role/profile, and load status.
import { create } from 'zustand';
import type { User } from 'firebase/auth';
import type { Role, UserProfile } from '../types';

interface AuthState {
  firebaseUser: User | null;
  profile: UserProfile | null;
  role: Role | null;
  loading: boolean;
  setFirebaseUser: (user: User | null) => void;
  setProfile: (profile: UserProfile | null, role: Role | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  firebaseUser: null,
  profile: null,
  role: null,
  loading: true,
  setFirebaseUser: (firebaseUser) => set({ firebaseUser }),
  setProfile: (profile, role) => set({ profile, role }),
  setLoading: (loading) => set({ loading }),
  reset: () => set({ firebaseUser: null, profile: null, role: null }),
}));
